import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38513871&scoped=true&lang=html&"
import script from "./marketingActivities.js?vue&type=script&lang=js&"
export * from "./marketingActivities.js?vue&type=script&lang=js&"
import style0 from "./marketingActivities.styl?vue&type=style&index=0&id=38513871&lang=stylus&scoped=true&"
import style1 from "./resetVant.styl?vue&type=style&index=1&id=38513871&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38513871",
  null
  
)

export default component.exports